export default __webpack_public_path__ + "static/media/img_pencil.8bd29886.svg";